// File Metadata:
// Filename: UserMenu.jsx
// Version: 1.00
// Created: 2026-06-14
// Last Modified: 2026-06-14
// Authors: GitHub Copilot
// Description: User dropdown menu component displaying user info and account actions

import React from 'react';
import { Menu, MenuItem, Divider, Box, Typography, Chip, ListItemIcon } from '@mui/material';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '@/store/slices/userSlice';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LogoutIcon from '@mui/icons-material/Logout';
import { alpha, useTheme } from '@mui/material/styles';

const UserMenu = ({ user, anchorEl, open, onClose }) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{ paper: { sx: { minWidth: 220, mt: 0.5 } } }}
    >
      {/* User info header */}
      <Box sx={{ px: 2, py: 1.5, mb: 0.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '0.9rem' }}>
          {user.name}
        </Typography>
        {/* Email — shown prominently to help distinguish multiple accounts */}
        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'monospace', fontSize: '0.78rem' }}>
          {user.email}
        </Typography>
        <Box sx={{ mt: 0.75 }}>
          <Chip
            label={user.role === 'parent' ? 'Parent' : 'Child'}
            size="small"
            sx={{
              height: 20,
              fontSize: '0.7rem',
              fontWeight: 600,
              bgcolor: alpha(theme.palette.primary.main, 0.15),
              color: theme.palette.primary.main,
              border: 'none',
            }}
          />
        </Box>
      </Box>

      <Divider sx={{ my: 0.5 }} />

      {user.role === 'parent' && (
        <MenuItem
          component={Link}
          to="/dashboard"
          onClick={onClose}
        >
          <ListItemIcon><DashboardIcon fontSize="small" /></ListItemIcon>
          Dashboard
        </MenuItem>
      )}
      <MenuItem component={Link} to="/profile" onClick={onClose}>
        <ListItemIcon><PersonOutlineIcon fontSize="small" /></ListItemIcon>
        Profile
      </MenuItem>

      <Divider sx={{ my: 0.5 }} />

      <MenuItem
        onClick={() => { onClose(); dispatch(logout()); }}
        sx={{ color: 'error.main' }}
      >
        <ListItemIcon sx={{ color: 'error.main' }}>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        Sign out
      </MenuItem>
    </Menu>
  );
};

export default UserMenu;
